import { Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { RacingOptionMarketTypes } from '@frontend/sports/racing/feature/models';

import { EachWayMarketHelperService } from '../../../../lib/option-group/each-way-market-helper.service';
import { BetslipV1Pick } from '../../../core/picks/betslip-v1-pick';
import { BetslipV2OptionMarketPick } from '../../../core/picks/betslip-v2-option-market-pick';
import {
    BetslipV2HorseRaceOptionMarketPick,
    BetslipV2OptionMarketXCastRacePick,
} from '../../../core/picks/sport-specific/betslip-v2-horse-race-picks';
import { BetslipOverAskPickBaseComponent } from './betslip-over-ask-pick-base.component';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskPickOptionMarketBaseComponent extends BetslipOverAskPickBaseComponent {
    constructor(
        private eachWayMarketHelper: EachWayMarketHelperService,
        siteCore: Sitecore,
    ) {
        super(siteCore);
    }

    get marketName(): string {
        if (!this.shouldShowBadge && this.props.overAskPick.isEachWay) {
            return `${this.pick.marketName.name} ${this.eachWayMarketHelper.getWinMarketNameFromPick(this.pick)}`;
        }

        if (
            (BetslipV2HorseRaceOptionMarketPick.isPick(this.pick) && this.pick.market.marketType?.toString() === RacingOptionMarketTypes.WinEw) ||
            BetslipV2OptionMarketXCastRacePick.isPick(this.pick)
        ) {
            return this.pick.betType;
        }

        return this.pick.marketName.name;
    }

    get pick(): BetslipV1Pick | BetslipV2OptionMarketPick {
        return this.props.overAskPick.pick as BetslipV1Pick | BetslipV2OptionMarketPick;
    }
}
